module.exports = __webpack_public_path__ + "img/tip_industry_graph.7c445798.png";